'use client';
import React from 'react';
import { Box, Flex, Grid, Text, backgroundToTokens, useBreakpointValue } from '../..';
import dsColors from '../../theme/foundation/color';
const colorData = [
    {
        variant: 'electricBlue',
        colorList: [
            dsColors.electricBlue[100],
            dsColors.electricBlue[160]
        ]
    },
    {
        variant: 'oceanBlue',
        colorList: [
            dsColors.oceanBlue[80],
            dsColors.oceanBlue[160]
        ]
    },
    {
        variant: 'pink',
        colorList: [
            dsColors.pink[100],
            dsColors.pink[160]
        ]
    },
    {
        variant: 'purple',
        colorList: [
            dsColors.purple[80],
            dsColors.purple[160]
        ]
    },
    {
        variant: 'turquoise',
        colorList: [
            dsColors.turquoise[100],
            dsColors.turquoise[160]
        ]
    }
];
const colors = Object.fromEntries(colorData.map(({ variant , colorList  })=>[
        variant,
        colorList.map((c)=>c.replace('#', ''))
    ]));
const hex = (decimalValue)=>{
    const hexValue = decimalValue.toString(16);
    return hexValue.length === 1 ? `0${hexValue}` : hexValue;
};
const getColorInGradientPercentage = (variant, percentage)=>{
    const [color1, color2] = colors[variant];
    const ratio = 1 - percentage / 100;
    const r = Math.ceil(Number.parseInt(color1.slice(0, 2), 16) * ratio + Number.parseInt(color2.slice(0, 2), 16) * (1 - ratio));
    const g = Math.ceil(Number.parseInt(color1.slice(2, 4), 16) * ratio + Number.parseInt(color2.slice(2, 4), 16) * (1 - ratio));
    const b = Math.ceil(Number.parseInt(color1.slice(4, 6), 16) * ratio + Number.parseInt(color2.slice(4, 6), 16) * (1 - ratio));
    return `#${hex(r)}${hex(g)}${hex(b)}`;
};
const getLinearGradient = (direction, variant)=>{
    const colorList = colors[variant];
    let gradientCss = '';
    gradientCss = direction === 'horizontal' ? 'linear-gradient(to right, ' : 'linear-gradient(to bottom, ';
    colorList.forEach((c, index)=>{
        gradientCss += index === colorList.length - 1 ? `#${c} 100%)` : `#${c} 0%, `;
    });
    return gradientCss;
};
const INLINE_PADDING = 10;
export const Stepper = (props)=>{
    const { background , variant ='electricBlue' , title , steps  } = props;
    const { bg , color  } = backgroundToTokens(background);
    const direction = useBreakpointValue({
        base: 'horizontal',
        sm: 'vertical'
    });
    if (steps.length === 1) return null;
    return /*#__PURE__*/ React.createElement(Flex, {
        as: "section",
        flexDirection: "column",
        gap: [
            '1.5rem',
            null,
            '2.5rem'
        ],
        w: "full"
    }, /*#__PURE__*/ React.createElement(Text, {
        textStyle: "lBold"
    }, title), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "start",
        flexDirection: [
            'column',
            null,
            'row'
        ],
        gap: [
            '1rem',
            '2rem'
        ],
        justifyContent: "space-between",
        position: "relative",
        px: [
            null,
            null,
            INLINE_PADDING
        ],
        w: [
            'fit-content',
            null,
            'full'
        ]
    }, steps.map((step, index)=>/*#__PURE__*/ React.createElement(Grid, {
            gridTemplateColumns: [
                '40px 16px 1fr',
                null,
                '60px'
            ],
            gridTemplateRows: [
                '40px 1fr',
                null,
                '60px 24px auto 8px 1fr'
            ],
            key: step.title,
            placeItems: "center",
            zIndex: 1
        }, /*#__PURE__*/ React.createElement(Text, {
            as: "span",
            backgroundColor: getColorInGradientPercentage(variant, 100 / (steps.length - 1) * index),
            borderRadius: "50%",
            gridColumn: "1",
            gridRow: "1",
            h: [
                '40px',
                null,
                '60px'
            ],
            lineHeight: [
                '40px',
                null,
                '60px'
            ],
            textAlign: "center",
            textColor: "white",
            textShadow: "0 1px #0006",
            textStyle: [
                'lBold',
                null,
                '3xl'
            ],
            w: [
                '40px',
                null,
                '60px'
            ]
        }, index + 1), /*#__PURE__*/ React.createElement(Text, {
            alignSelf: [
                'center',
                null,
                'unset'
            ],
            color: getColorInGradientPercentage(variant, 100 / (steps.length - 1) * index),
            gridColumn: [
                3,
                null,
                1
            ],
            gridRow: [
                1,
                null,
                3
            ],
            justifySelf: [
                'start',
                null,
                'unset'
            ],
            textAlign: "center",
            textStyle: "lBold",
            whiteSpace: "nowrap"
        }, step.title), /*#__PURE__*/ React.createElement(Text, {
            as: "p",
            color: color,
            gridColumn: [
                3,
                null,
                1
            ],
            gridRow: [
                2,
                null,
                5
            ],
            marginRight: [
                '1rem',
                null,
                'unset'
            ],
            maxW: [
                'unset',
                null,
                'calc(60px + 6rem)'
            ],
            minW: [
                'unset',
                null,
                'calc(60px + 6rem)'
            ],
            textAlign: [
                'unset',
                null,
                'center'
            ],
            textStyle: "m"
        }, step.description), direction === 'vertical' && index === steps.length - 1 && /*#__PURE__*/ React.createElement(Box, {
            backgroundColor: bg,
            gridColumn: "1",
            gridRow: "2",
            h: "full",
            w: "full"
        }))), /*#__PURE__*/ React.createElement(Box, {
        background: getLinearGradient(direction, variant),
        h: [
            '100%',
            null,
            '2px'
        ],
        left: [
            '20px',
            null,
            'unset'
        ],
        position: "absolute",
        top: [
            'unset',
            null,
            '30px'
        ],
        w: [
            '2px',
            null,
            `calc(100% - ${INLINE_PADDING}rem)`
        ],
        zIndex: 0
    })));
};

//# sourceMappingURL=stepper.js.map